import { addYears } from 'date-fns'
import { useI18n } from 'vue-i18n'
import { useActiveFacility } from '~/composables/use-active-facility'
import { useLocalization } from '~/composables/use-localization'
import { parseUtc } from '~/composables/support/localization'
import type { BookingPeriodAvailability } from '~/resources/graphql/graphql'

export type BookingPeriodData = {
    status: BookingPeriodAvailability
    opensAt?: string | null
}

export function useBookingPeriodMessage() {
    const { t } = useI18n({ useScope: 'global' })
    const facility = useActiveFacility()
    const { locale } = useLocalization()

    function openingMessage(
        period: Pick<BookingPeriodData, 'opensAt'>
    ): string {
        if (period.opensAt === null || period.opensAt === undefined) {
            return t('purchaseContract.bookingNotOpen')
        }
        const opensAt = parseUtc(period.opensAt)
        const date = new Intl.DateTimeFormat(locale.value, {
            year: opensAt > addYears(new Date(), 1) ? 'numeric' : undefined,
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            timeZone: facility.value.timezone
        }).format(opensAt)
        return t('purchaseContract.bookingOpens', { date })
    }
    return { openingMessage }
}
